import { type DirectiveBinding } from 'vue';

export const appLoaderTop = (
	el: HTMLElement,
	binding: DirectiveBinding<boolean>
) => {
	el.classList.toggle('app-loader-top', binding.value);
};
